const CTA_VARIATIONS = ['molly', '', 'patti']

/** Stable SSR/client CTA pair — avoids Math.random hydration mismatch and layout shift. */
export function getArticleCtaVariations(seed = '') {
  const hash = [...seed].reduce((acc, char) => acc + char.charCodeAt(0), 0)
  const first = CTA_VARIATIONS[hash % CTA_VARIATIONS.length]
  let second = CTA_VARIATIONS[(hash + 1) % CTA_VARIATIONS.length]

  if (second === first) {
    second = CTA_VARIATIONS[(hash + 2) % CTA_VARIATIONS.length]
  }

  return [first, second]
}
